import type { LocaleResources } from '../types';

/**
 * Chart related UI string resources
 * chart-view, chart-options, indicator-legend, etc.
 */
export const chartStr: LocaleResources['chartStr'] = {
  options: {
    title: 'Chart Settings',
    autoScale: 'Y-Axis Auto Scaling',
    showIndicatorValue: 'Show Indicator Value on Y-Axis',
    subChartMinHeight: 'Sub Chart Minimum Height',
    subChartMaxHeight: 'Sub Chart Maximum Height',
  },
  legend: {
    hide: 'Hide',
    config: 'Settings',
    delete: 'Delete',
    expand: 'Expand',
    collapse: 'Collapse',
    indicatorLegend: 'Indicator Legend {action}',
  },
  indicator: {
    selectTitle: 'Select Indicator',
  },
  orderTooltip: {
    manual: 'Manual',
    time: 'Time',
    amount: 'Amount',
    orderPrice: 'Order Price',
    profit: 'Profit',
    profitRate: 'Profit Rate',
    netProfit: 'Net Profit',
    netProfitRate: 'Net Profit Rate',
    signalPrice: 'Signal Price',
    smoothedPrice: 'Smoothed Price',
    splitStep: 'Split Step {step}',
    direction: 'Direction',
    entryRatio: '{orderType} Ratio',
  },
};
